import {
  INGREDIENT_RECIPES_PAGE_REQUEST,
  INGREDIENT_RECIPES_RECIPES_REQUEST,
  INGREDIENT_RECIPES_UPDATE_LIST_RECIPE,
  INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS,
  INGREDIENT_RECIPES_EXPORT_RECIPES,
  INGREDIENT_RECIPES_ON_CLICK_ROW,
  INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES,
  INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS,
  INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES_SHOW_MODAL,
  INGREDIENT_RECIPES_UPLOAD_FILE_FAILED,
  INGREDIENT_RECIPES_START_DOWNLOAD_ERROR_LIST_IMPORT_RECIPE,
  INGREDIENT_RECIPES_ADD_ITEMS_ON_SEARCH_ITEMS,
  INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS,
  INGREDIENT_RECIPES_ON_CLICK_DONE,
  INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET,
  INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL,
  INGREDIENT_RECIPES_CONFIRM_SUBMIT,
  INGREDIENT_RECIPES_SET_FILTER_ITEM,
  INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_CHANGE_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT,
  INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST,
  INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS,
  INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES,
  INGREDIENT_RECIPES_DELETE_ITEM,
  INGREDIENT_RECIPES_SAVE_RECIPES,
  INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET,
  INGREDIENT_RECIPES_UPDATE_RECIPES,
  INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET,
  INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID,
  INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID,
  INGREDIENT_RECIPES_SAVE_IMPORT_RECIPE,
} from 'actions/ingredients/recipes/constants';
import * as actIngredientRecipes from 'actions/ingredients/recipes';
import { put, call, takeLatest, select } from 'redux-saga/effects';
import FormData from 'form-data';
import { delay } from 'redux-saga';
import * as act from 'actions';
import * as actLoadingSpinner from 'actions/loadingSpinner';
import * as apiOutlets from 'api/outlets';
import * as apiProfile from 'api/profile';
import { postNewFile } from 'api/s3';
import { RECIPE } from 'utils/uploadS3Constants';
import * as apiIngredientRecipes from 'api/ingredients/recipes';
import * as actNotif from 'actions/notifications';
import {
  initialize,
  arrayPush,
  change,
  reset,
  arrayRemoveAll,
} from 'redux-form';
import * as clevertapIngredientRecipes from 'clevertap/ingredient/recipes';
import * as _ from 'lodash';
import { processingErrorMessageImportRecipe } from 'utils/formatter';
import * as actOutletList from 'actions/outletPages/list';

const getOutlet = state => state.form.search.values.outletIds;
const getAllOutlet = state => state.ingredients.recipes.outlets;
const getRecipeDetail = state => state.ingredients.recipes.recipesDetail;

const getCloneNotification = state =>
  state.outletPages.list.showCloneOutletNotification.notification;

function* getCloneOutletNotification() {
  const notification = yield select(getCloneNotification);
  return notification;
}

export function* pageRequest() {
  yield put(actLoadingSpinner.showPageLoadingSpinner(true));
  yield put(reset('recipes'));
  yield put(actIngredientRecipes.setOutlets([]));
  yield put(actIngredientRecipes.unSetFilterState());
  yield put(actIngredientRecipes.setRecipes([]));
  yield put(actIngredientRecipes.setRecipesDetail(null));
  yield put(actIngredientRecipes.closeRightColumn());
  yield put(act.showProgressBar());

  try {
    // get outlets
    const response = yield call(apiOutlets.outlets);
    yield put(actIngredientRecipes.setOutlets(response.data));
    const resProfile = yield call(apiProfile.getProfile);
    const params = {
      page: 1,
      keyword: '',
    };
    const { name } = resProfile.data.outlets.find(
      data => resProfile.data.outlet_id[0] === data.id
    );
    yield put(actIngredientRecipes.recipesRequest(params, []));
    yield put(
      initialize('search', {
        outletIds: [resProfile.data.outlet_id[0]],
        email: resProfile.data.email,
        outletName: name,
      })
    );
    const responseItem = yield call(apiIngredientRecipes.getItemDropdown);
    const formatResponseItem = [];
    responseItem.data.map(function(val) {
      formatResponseItem.push({ value: val.id, label: val.name, ...val });
    });
    yield put(actIngredientRecipes.setItemDropdown(formatResponseItem));
    clevertapIngredientRecipes.ingredientRecipesStart({
      outletIds: [resProfile.data.outlet_id[0]],
    });
    yield put(actOutletList.checkCloningOutletOnProgress());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* recipesRequest(request) {
  const {
    payload: { params, previousRecipes },
  } = request;
  yield put(act.showProgressBar());
  try {
    const resRecipes = yield call(apiIngredientRecipes.getRecipes, params);
    const resRecipesData = resRecipes.data;
    const recipes = previousRecipes.concat(resRecipesData.results);
    yield put(
      actIngredientRecipes.setTotalPage(resRecipesData.meta.total_pages)
    );
    yield put(
      actIngredientRecipes.setTotalCount(resRecipesData.meta.total_count)
    );
    yield put(actIngredientRecipes.setRecipes(recipes));
    yield put(actIngredientRecipes.setCurrentPage(params.page));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actLoadingSpinner.showPageLoadingSpinner(false));
  }
}

export function* recipeRequestAfterChanged(request) {
  const {
    payload: { params },
  } = request;
  const resRecipes = yield call(apiIngredientRecipes.getRecipes, params);
  const { data } = resRecipes;
  yield put(actIngredientRecipes.setTotalCount(data.meta.total_count));
}

export function* recipesFormOnChangeOutlet() {
  yield put(change('recipes', 'recipes', []));
}

export function* recipesFormOnClickCancel() {
  yield put(actIngredientRecipes.setRecipesDetail(null));
  yield put(actIngredientRecipes.closeRightColumn());
  yield put(reset('recipes'));
}

export function* onChangeOutletIdsFlow(request) {
  const {
    payload: { outletIds },
  } = request;
  const outlet = yield select(getOutlet);

  clevertapIngredientRecipes.ingredientRecipesChangeFilter({
    currentOutlet: outlet,
    outletIds,
  });
  yield put(actIngredientRecipes.closeRightColumn());
  yield put(actLoadingSpinner.showPageLoadingSpinner(true));
  yield put(actIngredientRecipes.setRecipes([]));
  yield put(actIngredientRecipes.setRecipesDetail(null));
  yield put(actIngredientRecipes.unSetFilterState());
  yield put(reset('recipes'));
  yield put(act.showProgressBar());
  try {
    yield call(apiOutlets.patchLogin, { id: outletIds });
    yield put(
      initialize('search', {
        outletIds,
      })
    );
    yield put(actIngredientRecipes.pageRequest());
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
  yield put(
    actIngredientRecipes.recipesRequest(
      {
        page: 1,
      },
      []
    )
  );
}

export function* exportRecipes(request) {
  try {
    yield put(act.showLoadingSpinner(true));
    const {
      payload: { params },
    } = request;
    const { data } = yield call(apiIngredientRecipes.getExportRecipes, params);
    yield put(actIngredientRecipes.setIdAsyncJob(data));
  } catch (error) {
    yield put(actIngredientRecipes.doneExportRecipe());
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  }
}

export function* importRecipes(request) {
  const {
    payload: { params, file },
  } = request;
  let imageURL;
  yield put(actIngredientRecipes.loadingUpload());
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('namespace', RECIPE);
    const { data } = yield postNewFile(formData);
    imageURL = data.download_file_url;
  } catch (err) {
    yield put(actIngredientRecipes.responseUploadFailed('error when upload'));
    yield put(actIngredientRecipes.nextStepCreateRecipes());
    clevertapIngredientRecipes.importRecipeFailed(params.outletId);
  }
  try {
    const { data } = yield call(apiIngredientRecipes.postImportRecipe, params, {
      uploadfile: imageURL,
    });
    yield put(actIngredientRecipes.setIdAsyncJob(data.async_job_id));
  } catch (e) {
    yield put(actIngredientRecipes.responseUploadFailed('Error Import Recipe'));
    clevertapIngredientRecipes.importRecipeFailed(params.outletId);
  }
}

export function* handleResponseFailedImportRecipe(request) {
  const {
    payload: { message, outletId },
  } = request;
  const emptyFileMsg = '["Cannot read an empty file, please try again"]';

  // validation static error message
  const isEmptyFileMessage = message === emptyFileMsg;

  const errorMessage = isEmptyFileMessage
    ? [message.substring(2, message.length - 2)]
    : // eslint-disable-next-line no-useless-escape
      message.replace(/[\'"{}[\]\\\/]/gi, '').split(',');

  // validate error message just one row, parse to string
  const messages =
    errorMessage.length === 1 || isEmptyFileMessage
      ? errorMessage[0]
      : processingErrorMessageImportRecipe(errorMessage);
  clevertapIngredientRecipes.importRecipeFailed(outletId);
  yield put(
    actIngredientRecipes.setMessageResponseFailedImportRecipe({ messages })
  );
}

export function* showImportModal(request) {
  const {
    payload: { outletId },
  } = request;
  yield put(actIngredientRecipes.setOpenCreateRecipesModal());
  clevertapIngredientRecipes.importRecipeStart(outletId);
}

export function* getErrorListImportRecipe(request) {
  const {
    payload: { params },
  } = request;
  try {
    yield put(act.showLoadingSpinner(true));
    const { data } = yield call(apiIngredientRecipes.getExportRecipes, params);
    yield put(actIngredientRecipes.setIdAsyncJob(data));
  } catch (err) {
    yield put(
      actIngredientRecipes.responseUploadFailed(
        'Error Download Error Import Recipe'
      )
    );
  }
}

export function* onClickRow(request) {
  const {
    payload: { recipes },
  } = request;
  clevertapIngredientRecipes.ingredientRecipesSelect({ recipe: recipes });
  const { recipe_ingredients } = recipes;
  const formatIngredientRecipes = [];
  recipe_ingredients.map(function(recipeIngredient) {
    formatIngredientRecipes.push({
      ...recipeIngredient,
      ingredient_avg: recipeIngredient.track_cogs
        ? recipeIngredient.cogs * recipeIngredient.quantity
        : null,
    });
  });
  yield put(actIngredientRecipes.setRecipesDetail(recipes));
  yield put(actIngredientRecipes.openRightColumn());
  yield put(
    initialize('recipes', {
      id: recipes.id,
      item_id: recipes.item_id,
      item_name: recipes.item_name,
      item_variant_name: recipes.item_variant_name || 'No Variant',
      item_variant_id: recipes.item_variant_id,
      recipe_ingredients: formatIngredientRecipes,
      ingredientsInventory: formatIngredientRecipes,
      sku: recipes.sku,
    })
  );
}

export function* onClickCreateRecipes() {
  yield put(reset('recipes'));
  yield put(reset('addIngredients'));
  yield put(
    initialize('recipes', {
      id: null,
      item_id: null,
      item_name: null,
      item_variant_id: null,
      item_variant_name: null,
      recipe_ingredients: [],
      ingredientsInventory: [],
    })
  );
  yield put(actIngredientRecipes.setRecipesDetail(null));
  yield put(
    actIngredientRecipes.setItemVariant([
      {
        value: 'Variant Option',
        name: 'Variant Option',
        is_recipe: false,
        isDisable: false,
      },
    ])
  );
  yield put(actIngredientRecipes.openRightColumn());
}

export function* onClickAddItems() {
  yield put(
    actIngredientRecipes.addIngredientsGetingredientRequest({
      page: 1,
      per_page: 100,
      keyword: '',
    })
  );
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null));
  yield put(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert());
  yield put(actIngredientRecipes.showAddItemsModal());
}

export function* addIngredientsGetItemsRequestFlow(request) {
  const {
    payload: {
      params: { previousItems, ...restParams },
    },
  } = request;
  if (restParams.keyword) {
    yield call(delay, 300);
  }
  try {
    yield put(actIngredientRecipes.addIngredientsShowLoading());
    const resItems = yield call(
      apiIngredientRecipes.getItemIngredient,
      restParams
    );
    const items = {
      results: resItems.data.results,
      total_pages: 9999,
      total_counts: 0,
    };
    if (restParams.page > 1) {
      if (items.results.length === 0) {
        items.total_pages = restParams.page - 1;
        items.currentPage = restParams.page - 1;
      } else {
        items.currentPage = restParams.page;
      }
      items.results = previousItems.concat(items.results);
    } else {
      items.currentPage = 1;
    }
    yield put(actIngredientRecipes.addIngredientsSetItems(items));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(actIngredientRecipes.addIngredientsHideLoading());
  }
}

export function* addIngredientsOnSearchItems(request) {
  // delay to prevent too many request
  yield call(delay, 100);
  const {
    payload: { keyword, outletId },
  } = request;
  yield put(
    actIngredientRecipes.addIngredientsGetingredientRequest({
      outlet_id: outletId,
      page: 1,
      per_page: 100,
      keyword,
    })
  );
  yield put(initialize('addIngredients', {}));
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null));
  yield put(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert());
}

export function* addItemVariantOnChangeItems(request) {
  const {
    payload: { selectedItem },
  } = request;
  const response = yield call(
    apiIngredientRecipes.getItemVariant,
    selectedItem.value
  );
  const formatResponseData = [];
  const responseItemVariant = response.data;
  if (responseItemVariant.length) {
    if (responseItemVariant.length === 1 && !responseItemVariant[0].name) {
      formatResponseData.push({
        name: 'No Variant',
        value: responseItemVariant[0].id,
        isDisable: true,
        is_recipe: responseItemVariant[0].is_recipe,
        sku: responseItemVariant[0].sku,
      });
      yield put(change('recipes', 'sku', responseItemVariant[0].sku));
    } else {
      formatResponseData.push({
        name: 'Variant Option',
        value: 'Variant Option',
        isDisable: false,
      });
      responseItemVariant.map(function(item) {
        formatResponseData.push({
          name: item.name,
          value: item.id,
          isDisable: item.is_recipe,
          is_recipe: item.is_recipe,
          sku: item.sku,
        });
      });
    }
  } else {
    formatResponseData.push({
      name: 'Variant Option',
      value: 'Variant Option',
      isDisable: true,
    });
  }
  yield put(change('recipes', 'item_variant_id', null));
  yield put(actIngredientRecipes.setItemVariant(formatResponseData));
}

export function* onClickDone() {
  yield put(actIngredientRecipes.closeRightColumn());
  yield put(actIngredientRecipes.setRecipesDetail(null));
}

export function* confirmSubmit(request) {
  const {
    payload: { values },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield put(actIngredientRecipes.hideConfirmSubmitModal());
    const formData = {
      recipes: { note: values.note, outlet_id: values.outlet_id },
    };
    const { recipes } = values;
    formData.recipes.history_details = [];
    recipes.forEach(a => {
      if (
        Math.abs(parseFloat(a.quantity) - parseFloat(a.beginning_stock)) >
        0.0000001
      ) {
        formData.recipes.history_details.push({
          ...a,
          end_stock: a.quantity - a.beginning_stock,
          recipes: a.quantity - a.beginning_stock,
        });
      }
    });
    yield call(apiIngredientRecipes.postRecipes, formData);
    yield put(reset('recipes'));
    yield put(actIngredientRecipes.pageRequest());
    yield put(
      actNotif.success(
        'Recipes has been created',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(actIngredientRecipes.closeRightColumn());
    yield put(act.hideProgressBar());
  }
}

function* setFilterRecipes(request) {
  yield call(delay, 200);
  yield put(actIngredientRecipes.setRecipes([]));
  const {
    payload: { keyword },
  } = request;
  yield put(actIngredientRecipes.setFilterState(keyword));
  yield put(act.showProgressBar());
  try {
    const params = {
      page: 1,
      keyword,
    };
    yield put(actIngredientRecipes.recipesRequest(params, []));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* addItemsOnSearchIngredientsModal(request) {
  yield put(actIngredientRecipes.addIngredientsSetItems([]));
  // delay to prevent too many request
  yield call(delay, 100);
  const {
    payload: { keyword },
  } = request;
  yield put(
    actIngredientRecipes.addIngredientsGetIngredientsRequestModal({
      page: 1,
      per_page: 100,
      keyword,
    })
  );
  yield put(initialize('addIngredients', {}));
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null));
  yield put(actIngredientRecipes.addIngredientsSetKeyword(keyword));
  yield put(actIngredientRecipes.addIngredientsHideAlreadyAddedAlert());
}

export function* addIngredientsOnCancelAddIngredients() {
  yield put(
    initialize('addIngredients', {
      ingredients: [],
    })
  );
  yield put(
    actIngredientRecipes.addIngredientsSetItems({
      results: [],
      total_pages: 0,
      total_counts: 0,
    })
  );
  yield put(actIngredientRecipes.hideAddIngredientsModal());
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null));
}

export function* addItemsOnChangeIngredientsModal(request) {
  const {
    payload: { ingredient, recipesForm },
  } = request;
  const recipeIngredients = recipesForm.recipe_ingredients;
  let formatQuantity = null;
  let formatAvgCost = null;
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null));
  yield put(actIngredientRecipes.addIngredientsSetIngredient(ingredient));
  yield put(change('addIngredients', 'ingredient_id', ingredient.id));
  yield put(change('addIngredients', 'ingredient_name', ingredient.name));
  yield put(change('addIngredients', 'unit_id', ingredient.unit_id));
  yield put(change('addIngredients', 'unit_name', ingredient.unit_name));
  yield put(change('addIngredients', 'cogs', ingredient.cogs));
  yield put(change('addIngredients', 'track_cogs', ingredient.track_cogs));

  if (recipeIngredients) {
    recipeIngredients.map(function(ingredientRecipe) {
      if (ingredientRecipe.ingredient_id === ingredient.id) {
        formatQuantity = ingredientRecipe.quantity;
        formatAvgCost = ingredientRecipe.ingredient_avg;
      }
    });
  }

  yield put(change('addIngredients', 'ingredient_avg', formatAvgCost));
  yield put(change('addIngredients', 'quantity', formatQuantity));
}

export function* addIngredientDetailRecipes(request) {
  const {
    payload: { values, recipesForm },
  } = request;
  const recipeIngredients = recipesForm.recipe_ingredients;
  const copyValues = [values];
  let replace = false;
  if (recipeIngredients) {
    recipeIngredients.map(function(ingredient) {
      if (ingredient.ingredient_id === values.ingredient_id) {
        replace = true;
      }
    });
    if (replace) {
      const newIngredientsRecipes = recipeIngredients.map(
        obj =>
          copyValues.find(o => o.ingredient_id === obj.ingredient_id) || obj
      );
      yield put(arrayRemoveAll('recipes', 'recipe_ingredients'));
      for (let i = 0; i < newIngredientsRecipes.length; i++) {
        yield put(
          arrayPush('recipes', 'recipe_ingredients', newIngredientsRecipes[i])
        );
      }
    } else {
      yield put(arrayPush('recipes', 'recipe_ingredients', values));
    }
  } else {
    yield put(arrayPush('recipes', 'recipe_ingredients', values));
  }

  yield put(actIngredientRecipes.hideAddIngredientsModal());
  yield put(actIngredientRecipes.addIngredientsSetIngredient(null));
}

export function* deleteItem(request) {
  const {
    payload: { recipe, previousRecipes },
  } = request;
  try {
    clevertapIngredientRecipes.ingredientRecipesDelete({ recipe });
    yield put(act.showProgressBar());
    // remove items
    let deletedIndex = -1;
    previousRecipes.forEach((pRecipes, index) => {
      if (pRecipes.id === recipe.id) {
        deletedIndex = index;
      }
    });
    if (deletedIndex !== -1) {
      previousRecipes.splice(deletedIndex, 1);
    }
    yield call(apiIngredientRecipes.deleteRecipesById, recipe.id);
    yield put(actIngredientRecipes.closeRightColumn());
    yield put(actIngredientRecipes.setRecipesDetail(null));
    yield put(actIngredientRecipes.hideDeleteModal());
    yield put(actIngredientRecipes.recipesRequest({ page: 1 }, []));
    yield put(reset('recipes'));
    yield put(
      actNotif.success(
        'Recipes was successfully removed.',
        yield getCloneOutletNotification()
      )
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onSaveRecipes(request) {
  const {
    payload: { recipe, previousRecipes },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield put(actIngredientRecipes.isSubmittingForm(true));

    const allOutlet = yield select(getAllOutlet);
    clevertapIngredientRecipes.ingredientRecipesCreate({
      recipe,
      allOutlet: false,
      outlets: allOutlet,
    });
    const responseCreateRecipes = yield call(
      apiIngredientRecipes.createRecipes,
      recipe
    );
    const updatedRecipes = responseCreateRecipes.data;
    previousRecipes.unshift(updatedRecipes);
    yield put(initialize('recipes', recipe));
    yield put(actIngredientRecipes.setRecipes(previousRecipes));
    yield put(reset('recipes'));
    const newIngredientsInventory = [...recipe.recipe_ingredients];
    _.forEach(newIngredientsInventory, val => {
      _.forEach(updatedRecipes.recipe_ingredients, val2 => {
        if (val2.ingredient_id === val.ingredient_id) {
          val.in_stock = val2.in_stock;
        }
      });
    });
    yield put(
      initialize('recipes', {
        id: responseCreateRecipes.data.id,
        item_id: recipe.item_id,
        item_name: recipe.item_name,
        item_variant_name: recipe.item_variant_name || 'No Variant',
        item_variant_id: recipe.item_variant_id,
        recipe_ingredients: newIngredientsInventory,
        ingredientsInventory: newIngredientsInventory,
      })
    );
    yield put(
      actIngredientRecipes.setRecipesDetail(responseCreateRecipes.data)
    );
    yield put(
      actNotif.success(
        'Recipes was successfully saved.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actIngredientRecipes.updateListRecipe({ page: 1 }, []));
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actIngredientRecipes.isSubmittingForm(false));
  }
}

export function* onSaveRecipesAllOutlet(request) {
  const {
    payload: { recipe, previousRecipes },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield put(actIngredientRecipes.isSubmittingForm(true));

    const allOutlet = yield select(getAllOutlet);
    clevertapIngredientRecipes.ingredientRecipesCreate({
      recipe,
      allOutlet: true,
      outlets: allOutlet,
    });
    const responseCreateRecipes = yield call(
      apiIngredientRecipes.createRecipesAllOutlet,
      recipe
    );
    yield put(actIngredientRecipes.updateListRecipe({ page: 1 }, []));
    const responseData = responseCreateRecipes.data;
    const newRecipes = responseData.current_recipe;
    if (responseData.outlet_success && responseData.outlet_success.length > 0) {
      yield put(
        actIngredientRecipes.setCreatedOutlets({
          outletsFailed: responseData.outlet_failed,
          outletsSuccess: responseData.outlet_success,
        })
      );
      yield put(reset('recipes'));
      if (newRecipes) {
        const newIngredientsInventory = [...recipe.recipe_ingredients];
        _.forEach(newIngredientsInventory, val => {
          _.forEach(newRecipes.recipe_ingredients, val2 => {
            if (val2.ingredient_id === val.ingredient_id) {
              val.in_stock = val2.in_stock;
            }
          });
        });
        const newRecipe = [...previousRecipes, newRecipes];
        yield put(actIngredientRecipes.setRecipes(newRecipe));
        yield put(
          initialize('recipes', {
            id: newRecipes.id,
            item_id: recipe.item_id,
            item_name: recipe.item_name,
            item_variant_name: recipe.item_variant_name || 'No Variant',
            item_variant_id: recipe.item_variant_id,
            recipe_ingredients: newIngredientsInventory,
            ingredientsInventory: newIngredientsInventory,
          })
        );
        yield put(actIngredientRecipes.setRecipesDetail(newRecipes));
      } else {
        yield put(actIngredientRecipes.closeRightColumn());
      }
      yield put(actIngredientRecipes.showSaveToAllOutletsModal());
    } else {
      yield put(
        actNotif.error(
          'Failed to save recipe. There may be one or more conflict in your item attributes (item name, variant, category and SKU).',
          yield getCloneOutletNotification()
        )
      );
    }
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(actIngredientRecipes.isSubmittingForm(false));
    yield put(act.hideProgressBar());
  }
}

export function* onUpdateRecipes(request) {
  const {
    payload: { recipe, previousRecipes },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield put(actIngredientRecipes.isSubmittingForm(true));
    const responseUpdateRecipes = yield call(
      apiIngredientRecipes.updateRecipes,
      recipe.id,
      recipe
    );
    const newRecipes = responseUpdateRecipes.data;
    previousRecipes.forEach((previousRecipe, index) => {
      if (newRecipes.item_variant_id === previousRecipe.item_variant_id) {
        previousRecipes[index] = { ...newRecipes };
      }
    });
    yield put(initialize('recipes', recipe));
    yield put(actIngredientRecipes.setRecipes(previousRecipes));
    yield put(reset('recipes'));
    yield put(
      initialize('recipes', {
        id: newRecipes.id,
        item_id: recipe.item_id,
        item_name: recipe.item_name,
        item_variant_name: recipe.item_variant_name || 'No Variant',
        item_variant_id: recipe.item_variant_id,
        recipe_ingredients: recipe.recipe_ingredients,
        ingredientsInventory: recipe.recipe_ingredients,
      })
    );
    yield put(actIngredientRecipes.setRecipesDetail(newRecipes));
    yield put(
      actNotif.success(
        'Recipes was successfully updated.',
        yield getCloneOutletNotification()
      )
    );
    yield put(actIngredientRecipes.onClickRow(newRecipes));
    clevertapIngredientRecipes.ingredientRecipesUpdate({ recipe });
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actIngredientRecipes.isSubmittingForm(false));
  }
}

export function* onUpdateRecipesAllOutlet(request) {
  const {
    payload: { recipe, previousRecipes },
  } = request;

  const currentRecipe = yield select(getRecipeDetail);
  const allOutlet = yield select(getAllOutlet);

  try {
    yield put(act.showProgressBar());
    yield put(actIngredientRecipes.isSubmittingForm(true));
    const responseUpdateRecipes = yield call(
      apiIngredientRecipes.updateRecipesAllOutlet,
      recipe.id,
      recipe
    );
    const responseData = responseUpdateRecipes.data;
    if (responseData.outlet_success && responseData.outlet_success.length > 0) {
      yield put(
        actIngredientRecipes.setCreatedOutlets({
          outletsFailed: responseData.outlet_failed,
          outletsSuccess: responseData.outlet_success,
        })
      );
      yield put(reset('recipes'));
      yield put(actIngredientRecipes.showSaveToAllOutletsModal());
      const updatedRecipes = responseData.current_recipe;
      if (updatedRecipes) {
        previousRecipes.forEach((previousRecipe, index) => {
          if (
            updatedRecipes.item_variant_id === previousRecipe.item_variant_id
          ) {
            previousRecipes[index] = { ...updatedRecipes };
          }
        });
        yield put(actIngredientRecipes.setRecipes(previousRecipes));
        yield put(
          initialize('recipes', {
            id: updatedRecipes.id,
            item_id: recipe.item_id,
            item_name: recipe.item_name,
            item_variant_name: recipe.item_variant_name || 'No Variant',
            item_variant_id: recipe.item_variant_id,
            recipe_ingredients: recipe.recipe_ingredients,
            ingredientsInventory: recipe.recipe_ingredients,
          })
        );
        yield put(actIngredientRecipes.setRecipesDetail(updatedRecipes));
      } else {
        yield put(actIngredientRecipes.closeRightColumn());
      }
      clevertapIngredientRecipes.ingredientRecipesUpdateAllOutlet({
        previousRecipe: currentRecipe,
        recipe,
        outlets: allOutlet,
      });
    } else {
      yield put(
        actNotif.error(
          'Failed to save recipe. There may be one or more conflict in your item attributes (item name, variant, category and SKU).',
          yield getCloneOutletNotification()
        )
      );
    }
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
    yield put(actIngredientRecipes.isSubmittingForm(false));
  }
}

export function* setIngredientByVariantId(request) {
  const {
    payload: { itemVariant, recipesForm, selectedVariant },
  } = request;
  try {
    yield put(act.showProgressBar());
    const response = yield call(
      apiIngredientRecipes.getRecipesByVariantId,
      itemVariant.value
    );
    const recipe = response.data;
    const recipeIngredient = recipe.recipe_ingredients;
    const formatIngredientRecipes = [];
    recipeIngredient.map(function(ing) {
      formatIngredientRecipes.push({
        ingredient_id: ing.ingredient_id,
        ingredient_name: ing.ingredient_name,
        quantity: ing.quantity,
        unit_name: ing.unit_name,
        ingredient_avg: ing.track_cogs ? ing.cogs * ing.quantity : null,
        in_stock: ing.in_stock,
        cogs: ing.cogs,
        track_cogs: ing.track_cogs,
        recipe_id: ing.recipe_id,
        unit_id: ing.unit_id,
      });
    });
    yield put(
      initialize('recipes', {
        item_id: recipesForm.item_id,
        item_name: recipesForm.item_name,
        item_variant_id: selectedVariant,
        item_variant_name: recipesForm.item_variant_name,
        recipe_ingredients: formatIngredientRecipes,
      })
    );
  } catch (error) {
    yield put(
      actNotif.error(error.message, yield getCloneOutletNotification())
    );
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* unSetIngredientByItemVariant() {
  yield put(act.showProgressBar());
  yield put(arrayRemoveAll('recipes', 'recipe_ingredients'));
  yield put(act.hideProgressBar());
}

export default function* saga() {
  yield takeLatest(INGREDIENT_RECIPES_PAGE_REQUEST, pageRequest);
  yield takeLatest(INGREDIENT_RECIPES_RECIPES_REQUEST, recipesRequest);
  yield takeLatest(INGREDIENT_RECIPES_SET_FILTER_ITEM, setFilterRecipes);
  yield takeLatest(
    INGREDIENT_RECIPES_ON_CHANGE_OUTLET_IDS,
    onChangeOutletIdsFlow
  );
  yield takeLatest(INGREDIENT_RECIPES_EXPORT_RECIPES, exportRecipes);
  yield takeLatest(INGREDIENT_RECIPES_SAVE_IMPORT_RECIPE, importRecipes);
  yield takeLatest(
    INGREDIENT_RECIPES_UPDATE_LIST_RECIPE,
    recipeRequestAfterChanged
  );
  yield takeLatest(INGREDIENT_RECIPES_ON_CLICK_ROW, onClickRow);
  yield takeLatest(
    INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES,
    onClickCreateRecipes
  );
  yield takeLatest(INGREDIENT_RECIPES_ON_CLICK_ADD_ITEMS, onClickAddItems);
  yield takeLatest(
    INGREDIENT_RECIPES_ON_CLICK_CREATE_RECIPES_SHOW_MODAL,
    showImportModal
  );
  yield takeLatest(
    INGREDIENT_RECIPES_UPLOAD_FILE_FAILED,
    handleResponseFailedImportRecipe
  );
  yield takeLatest(
    INGREDIENT_RECIPES_START_DOWNLOAD_ERROR_LIST_IMPORT_RECIPE,
    getErrorListImportRecipe
  );
  yield takeLatest(INGREDIENT_RECIPES_ON_CLICK_DONE, onClickDone);
  yield takeLatest(
    INGREDIENT_RECIPES_RECIPES_FORM_ON_CHANGE_OUTLET,
    recipesFormOnChangeOutlet
  );
  yield takeLatest(
    INGREDIENT_RECIPES_RECIPES_FORM_ON_CLICK_CANCEL,
    recipesFormOnClickCancel
  );
  yield takeLatest(INGREDIENT_RECIPES_CONFIRM_SUBMIT, confirmSubmit);
  yield takeLatest(
    INGREDIENT_RECIPES_GET_INGREDIENT_REQUEST,
    addIngredientsGetItemsRequestFlow
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_ITEMS_ON_SEARCH_ITEMS,
    addIngredientsOnSearchItems
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_ITEMS_VARIANT_ON_CHANGE_ITEMS,
    addItemVariantOnChangeItems
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_CHANGE_INGREDIENTS,
    addItemsOnChangeIngredientsModal
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_INGREDIENTS_ON_SEARCH_INGREDIENTS,
    addItemsOnSearchIngredientsModal
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_INGREDIENTS_CANCEL_ADD_INGREDIENTS,
    addIngredientsOnCancelAddIngredients
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_INGREDIENTS_HIDE_ALREADY_ADDED_ALERT,
    confirmSubmit
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_INGREDIENTS_GET_INGREDIENTS_REQUEST,
    addIngredientsGetItemsRequestFlow
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_ITEMS_ON_CHANGE_ITEMS,
    addItemsOnChangeIngredientsModal
  );
  yield takeLatest(
    INGREDIENT_RECIPES_ADD_INGREDIENT_DETAIL_RECIPES,
    addIngredientDetailRecipes
  );
  yield takeLatest(INGREDIENT_RECIPES_DELETE_ITEM, deleteItem);
  yield takeLatest(INGREDIENT_RECIPES_SAVE_RECIPES, onSaveRecipes);
  yield takeLatest(
    INGREDIENT_RECIPES_SAVE_RECIPES_ALL_OUTLET,
    onSaveRecipesAllOutlet
  );
  yield takeLatest(INGREDIENT_RECIPES_UPDATE_RECIPES, onUpdateRecipes);
  yield takeLatest(
    INGREDIENT_RECIPES_UPDATE_RECIPES_ALL_OUTLET,
    onUpdateRecipesAllOutlet
  );
  yield takeLatest(
    INGREDIENT_RECIPES_SET_INGREDIENT_BY_VARIANT_ID,
    setIngredientByVariantId
  );
  yield takeLatest(
    INGREDIENT_RECIPES_UNSET_INGREDIENT_BY_VARIANT_ID,
    unSetIngredientByItemVariant
  );
}
